// DrawerProvider.jsx or App.jsx
import React, { ReactNode } from "react";
import { Drawer } from "@mui/material";
import TradingViewChart from "components/TradingViewChart"; // Adjust path
import useDrawerStore from "store/DrawerStore";
import { AdvancedRealTimeChart } from "react-ts-tradingview-widgets";

interface DrawerProviderProps {
  children: ReactNode;
}

const TradingChartProvider: React.FC<DrawerProviderProps> = ({ children }) => {
  const { selectedSymbol, isOpen, closeDrawer } = useDrawerStore();

  return (
    <>
      {children}
      <Drawer
        anchor="right"
        open={isOpen}
        onClose={closeDrawer}
        PaperProps={{
          sx: { width: "60%", height: "90%", top: "8%", position: "absolute" },
        }}
      >
        {
          selectedSymbol && (
            <AdvancedRealTimeChart
              width={"100%"}
              symbol={selectedSymbol}
              interval="D"
              timezone="Asia/Kolkata"
              studies={[
                {
                  id: "MASimple@tv-basicstudies",
                  inputs: { length: 50 },
                  color: "#FF5733",
                  plots: {
                    plot_0: {
                      lineWidth: 4,
                      color: "#000000",
                    },
                  },
                } as any,
                {
                  id: "MASimple@tv-basicstudies",
                  inputs: { length: 20 },
                  color: "#33FF57",
                } as any,
              ]}
            />
          )
          // <TradingViewChart symbol={selectedSymbol} />
        }
      </Drawer>
    </>
  );
};

export default TradingChartProvider;
